import React from 'react'
import DataTable from '../../DataTable/DataTable'
//import I18n from "i18n-js/index.js.erb"
import DateHelper from '../../DateHelper/DateHelper';

import clsx from "clsx"
import I18n from 'i18n-js';

export default class ReservationCardDetails extends React.Component {
  constructor(props) {
    super(props);
  };

  render() {
    this.setStatusDisplay()
    var tabClasses = clsx({
      'active': this.props.active_tab == 'details',
      'tab-pane': true
    });
    let dateOfBooking = DateHelper.printDateToScreen(this.props.reservation.created_at, this.props.date_format, true)

    return(

      <div className={tabClasses} id='details'>
        <div className="panel panel-default">
          <div className="panel-body">
            <h3 className="panel-heading-text">{I18n.t("rooms")}</h3>
            <DataTable
              endpoint={this.props.reservation_segments_path}
              date_format={this.props.date_format}
              time_format={this.props.time_format}
              reservation_segments={true}
              tab_data_table={true}
              currency_unit={I18n.t('number.currency.format.unit')}
              delimiter={I18n.t('number.currency.format.delimiter')}
              separator={I18n.t('number.currency.format.separator')} />
          </div>
        </div>
        <div className='panel panel-default'>
          <div className='panel-heading'>
            <h3 className="panel-title pull-left">{I18n.t("reservation_details")}</h3>
            <div className="clearfix"></div>

          </div>

          <div className="panel-body container">

              <div className="row">
                {/* <div className="col-md-3">
                  <label>{I18n.t('status')}</label>
                  <div>{this.capitalizeFirstLetters(I18n.t(this.setStatusDisplay()))}</div>
                </div> */}
                {/* <div className="col-md-3">
                  <label>{I18n.t('confirmation_number')}</label>
                  <div>{this.props.reservation.confirmation_number ? this.props.reservation.confirmation_number : null}</div>
                </div> */}
                <div className="col-md-3">
                  <label>{I18n.t('booked_by')}</label>
                  <div>{this.props.reservation.customer ? this.props.reservation.customer.full_name_and_email_address : null}</div>
                </div>
                <div className="col-md-3">
                  <label>{I18n.t('date_of_booking')}</label>
                  <div>{dateOfBooking}</div>

                </div>
                <div className="col-md-3">
                  <label>{I18n.t('reservation_source')}</label>
                  <div>{this.props.reservation.source}</div>
                </div>
                <div className='col-md-3'>
                <label>{I18n.t('booking_card')}</label>
                {
                  this.props.reservation.card
                  ?
                    <label className="customer-cards-label flexed">
                      <span className={"credit-card-icon small " + this.props.reservation.card.brand}></span>
                      <span>{I18n.t('ending_in').toLowerCase()} {this.props.reservation.card.last_4} {I18n.t('exp')} {this.props.reservation.card.month}/{this.props.reservation.card.year} </span>
                      <button type="button" className="btn btn-primary btn-sm modal-iframe edit-booking-card" data-fullscreen="true" data-nested="true" href={this.props.edit_reservation_cc_path}>
                        <span className="ss-write">
                          <span className="edit-span">Edit</span>
                        </span>
                      </button>
                    </label>
                  :
                    <label className="customer-cards-label flexed">
                      {I18n.t('none')}
                      <button type="button" className="btn btn-primary btn-sm modal-iframe edit-booking-card" data-fullscreen="true" data-nested="true" href={this.props.edit_reservation_cc_path}>
                        <span className="ss-write">
                          <span className="edit-span">Edit</span>
                        </span>
                      </button>
                    </label>
                }
                  
                </div>
              </div>
              {/* <div className="row">

                <div className="col-md-3">
                  <label>{I18n.t('lead_days')}</label>
                  <div>{this.props.reservation.lead_days} {this.props.reservation.lead_days == 1 ? I18n.t('day') : I18n.t('days')} <span className="ss-help help" title={I18n.t('number_of_days_between_date_of_booking_and_start_date')}></span></div>
                </div>
              </div> */}

          </div>
        </div>
      </div>
    );
  };


  capitalizeFirstLetters(string) {
    return string.toLowerCase().split(' ').map((s) => s.charAt(0).toUpperCase() + s.substring(1)).join(' ');
  };

  setStatusDisplay(){
    if(this.props.reservation.status === 'active'){
      var noShowCount = 0
      return this.props.reservation.reservation_segments.reduce((acc, seg) => {
        seg.status === 'no_show' ? noShowCount += 1 : null;
        if (noShowCount === this.props.reservation.reservation_segments.length){
          return acc = 'no_show'
        } else {
          acc = 'active'
        };
        return acc
      }, 0);
    } else{
      return this.props.reservation.status
    };
  };
 };
